export enum STATUSES {
  draft = "#ffdaa9",
  onHold = "#a2c7f2",
  pending = "#ffeea6",
  dismissed = "#ff8f8f",
  accepted = "#a5f5ff",
  completed = "#9df7d9",
}

export enum OrderViewConstants {
  LIST = "LIST",
  BOARD = "BOARD",
}

export enum CREATE_ORDER_STEPS {
  INIT,
  CATEGORIES,
  ITEM_DETAILS,
}

export enum CREATE_ORDER_PACKAGE_STEPS {
  INIT,
  FIND_CUSTOMER,
  CREATE_CUSTOMER,
  SELECTED_CUSTOMER,
  EDIT_CUSTOMER,
  CONFIRM_ORDER,
  CONFIRM_PREVIEW_ORDER,
}

export enum CREATE_ORDER_CUSTOMER_STEPS {
  CUSTOMER_INFO,
  CUSTOMER_ORDERS,
  CUSTOMER_ORDER_DETAILS,
}

export enum ORDER_STEPS {
  INIT,
  CONFIG,
  CONFIRM,
}

export enum ORDER_STATUS {
  CLOSED = "CLOSED",
  CANCELED = "CANCELED",
  IN_TRANSIT = "IN_TRANSIT",
  OPENED = "OPENED",
  PENDING = "PENDING",
  REJECTED = "REJECTED",
  VOIDED = "VOIDED",
  DRAFT = "DRAFT",
  FAILED = "FAILED",
  ACCEPTED = "ACCEPTED",
}

export enum ORDER_PAYMENT_STATUS {
  VOIDED = "Voided",
  PARTIALLY_PAID = "Partially Paid",
  UNPAID = "Unpaid",
  PAID = "Paid",
  PARTIALLY_REFUNDED = "Partially Refunded",
}

export enum ORDER_OPTION_TYPE {
  OTHER = "OTHER",
  DELIVERY = "DELIVERY",
  PICKUP = "PICKUP",
  DINE = "DINE",
}

export enum ITEM_PRICING_TYPE {
  FIXED = "FIXED",
  VARIABLE = "VARIABLE",
}

export enum EXTRA_CHARGE_TYPE {
  PERCENTAGE = "PERCENTAGE",
  FIXED = "FIXED",
}

export enum DISCOUNT_APPLIED_ON {
  ITEM = "ITEM",
  SALE = "SALE",
}

export enum NAME_LOCAL_NAME_KEY {
  en = "name",
  ar = "local_name",
}

export enum NAME_LOCAL_DESCRIPTION_KEY {
  en = "description",
  ar = "local_description",
}

export enum NAME_EN_AR_KEY {
  en = "name_en",
  ar = "name_ar",
}

export enum ORDER_SOURCE {
  CALLCENTER = "CALLCENTER",
  REGISTER = "REGISTER",
  TALABAT = "TALABAT",
}

export enum EXPAND_COLLECTION_STEPS {
  CREATE_ORDER = "CREATE_ORDER",
  ADD_ITEM = "ADD_ITEM",
  CONFIRM_ORDER = "CONFIRM_ORDER",
  PREVIEW_ORDER = "PREVIEW_ORDER",
  EDIT_ORDER = "EDIT_ORDER",
  BASKET_EMPTY = "BASKET_EMPTY",
  SHOW_CUSTOMER = "SHOW_CUSTOMER",
  SHOW_ORDER_INFO = "SHOW_ORDER_INFO",
  SHOW_ITEM_INFO = "SHOW_ITEM_INFO",
}
